import { render, staticRenderFns } from "./AddParticipantTournament.vue?vue&type=template&id=8e0e5136"
import script from "./AddParticipantTournament.vue?vue&type=script&lang=js"
export * from "./AddParticipantTournament.vue?vue&type=script&lang=js"
import style0 from "./AddParticipantTournament.vue?vue&type=style&index=0&id=8e0e5136&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports